import React, { useEffect, useState, useContext } from 'react';
import { Modal, Form, Button, message } from 'antd';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import { ModalContext } from '../../../../shared/context/ModalContext';
import { CommonCloudFirestore } from '../../../services/CommonCloudFirestore';
import { DOCUMENT_PRODUCT, DOCUMENT_SECTION_DETAIL, LISTENER_SECTION_DETAILS } from '../../../../shared/types/firestoreType';

import imageCompression from 'browser-image-compression';
import commonCloudStorage from '../../../services/CommonCloudStorage';
import global from '../../../../shared/utility/global';
import FormContent from './FormContent';

export default function Index(props) {
    const modal = useContext(ModalContext);
    const productFirestore = new CommonCloudFirestore(DOCUMENT_PRODUCT);
    const sectionDetailFirestore = new CommonCloudFirestore(DOCUMENT_SECTION_DETAIL);

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(undefined);
    const [products, setProducts] = useState([]);

    const config = {
        maxSizeMB: 1,
        maxWidthOrHeight: 640,
        useWebWorker: true,
    };

    useEffect(() => {
        form.setFieldsValue({
            visible: true,
            productIds: []
        });
        onLoad();
    }, [props.id]);

    const onLoad = async () => {
        setLoading(true);

        const _products = await productFirestore.getDocuments();
        setProducts(_products);

        if (props.id) {
            const response = await sectionDetailFirestore.getDocumentById(props.id);
            form.setFieldsValue(response);
            setFile({ url: response.imageUrl });
        }

        setLoading(false);
    };

    const onSave = async () => {
        var validations = await form.validateFields().then(() => true).catch(() => false);
        if (!validations) {
            message.warning('Por favor completa los datos del formulario.', 7);
            return;
        }

        if (file === undefined) {
            message.warning('Por favor agregue una imagen.', 7);
            return;
        }

        modal.confirm("¿Esta seguro de realizar la acción?", async () => {
            setLoading(true);

            if (!file.url) {
                const blobFile = await imageCompression(file, config);
                const stringBase64File = await global.blobToBase64(blobFile);
                var imageUrl = await commonCloudStorage.uploadFromStringBase64(stringBase64File, `${DOCUMENT_SECTION_DETAIL}/` + file.storageFilename);
                if (!imageUrl) {
                    message.error('Ocurrió un error al subir la imagen, por favor vuelva a intentarlo.', 7);
                    return;
                }
            }

            var documentData = form.getFieldValue();
            documentData.index = 0;
            documentData.sectionId = props.parentId;
            documentData.imageUrl = !file.url ? imageUrl : file.url;
            documentData.title = documentData.title ?? '';
            documentData.subTitle = documentData.subTitle ?? '';

            var response = await sectionDetailFirestore.setDocument(props.id, documentData, [LISTENER_SECTION_DETAILS]);

            if (response)
                message.success(`Item ${props.id === '' ? 'registrado' : 'modificado'} correctamente.`, 7);
            else
                message.error('Ocurrió un error inesperado.', 7);

            setLoading(false);
            onCancel();
            setFile(undefined);
            props.onLoad();
        });
    };

    const onBefore = async (file) => {
        const allowedExtensions = ["image/png", "image/jpg", "image/jpeg", "image/gif", "image/tiff", "image/svg+xml", "image/webp"];
        const allowedExtensionsValid = allowedExtensions.includes(file.type);

        if (!allowedExtensionsValid) {
            message.error(`${file.name} no es una imagen valida.`, 7);
            return;
        }

        file.stringBase64 = await global.getBase64(file);
        file.storageFilename = uuidv4() + '.' + file.name.split('.')[file.name.split('.').length - 1];
        setFile(file);
    };

    const onCancel = (prop) => {
        if (prop === undefined || !prop?.target?.className?.toString().match("ant-modal-wrap") || prop?.type === "keydown") {
            form.resetFields();
            props.onCancel();
        }
    };

    return (
        <Modal
            title={props.id === '' ? "Nuevo Item" : "Modificar Item"}
            open={props.open}
            destroyOnClose={true}
            onCancel={onCancel}
            width={600}
            footer={[
                <Button key="1" onClick={onCancel}>
                    <CloseOutlined /> Cancelar
                </Button>,
                <Button key="2" onClick={onSave} type={'primary'}>
                    <SaveOutlined /> Guardar
                </Button>
            ]}
        >
            <FormContent
                form={form}
                loading={loading}
                file={file}
                products={products}
                onBefore={onBefore}
            />
        </Modal>
    );
}